import { FC } from 'react'
import { Box } from '../../../../components/box/box.component'
import { navContainerClass } from './index.class'

export const NavContainer: FC<{ children?: any; setScroll?: any; context: any }> = props => {
  const { children, setScroll } = props

  const { base } = navContainerClass.setProps({})

  return (
    <Box
      baseline="surface"
      className={base}
      onScroll={(e: any) => {
        if (e.target.scrollTop < 1) {
          setScroll(false)
        } else {
          setScroll(true)
        }
      }}
    >
      {children}
    </Box>
  )
}
